const dev = {
  UPLOAD_URL:
    "https://dieyu8qnp8.execute-api.us-east-1.amazonaws.com/staging/upload",
  IMAGE_URL: "http://localhost:3030/images",
  SAVE_URL:
    "https://dieyu8qnp8.execute-api.us-east-1.amazonaws.com/staging/save",
};

const prod = {
  UPLOAD_URL:
    "https://dieyu8qnp8.execute-api.us-east-1.amazonaws.com/staging/upload",
  IMAGE_URL: "https://t2t-smile-file-user-images.s3.amazonaws.com",
  SAVE_URL:
    "https://dieyu8qnp8.execute-api.us-east-1.amazonaws.com/staging/save",
};

const config = process.env.REACT_APP_STAGE === "production" ? prod : dev;

export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config,
};
